/**
 * Canonical wizard-2 URL via pushState before Richpanel loads.
 * Richpanel hides on /quiz/ paths at init and on pushState (not replaceState).
 * Uses pushState only — no location.replace (Shopify /pages/wizard-2 ↔ pretty URL loop).
 */
(function () {
  var URL_PREFIX = '/wizard-2';
  var STORAGE_KEY = 'wizard-2-pet-data';

  var STEP_PATHS = {
    get_started: URL_PREFIX + '/quiz/get-started',
    name: URL_PREFIX + '/quiz/name',
    spayed: URL_PREFIX + '/quiz/spayed',
    age: URL_PREFIX + '/quiz/age',
    breed: URL_PREFIX + '/quiz/breed',
    weight: URL_PREFIX + '/quiz/weight',
    composition: URL_PREFIX + '/quiz/composition',
    activity: URL_PREFIX + '/quiz/activity',
    allergies: URL_PREFIX + '/quiz/allergies',
    snacks: URL_PREFIX + '/quiz/snacks',
    email: URL_PREFIX + '/quiz/email',
    calculation: URL_PREFIX + '/quiz/calculation',
    plan_overview: URL_PREFIX + '/plan/overview',
    plan_onetime: URL_PREFIX + '/plan/overview',
    profile: URL_PREFIX + '/profile'
  };

  function getLocalePrefix(pathname) {
    var match = pathname.match(/^(\/[a-z]{2}(-[a-z]{2})?)(?=\/|$)/);
    return match ? match[1] : '';
  }

  function normalizePath(pathname) {
    var localePrefix = getLocalePrefix(pathname);
    var path = localePrefix ? pathname.slice(localePrefix.length) || '/' : pathname;

    if (path.indexOf('/pages/wizard-two') === 0) {
      path = path.replace('/pages/wizard-two', '/pages/wizard-2');
    }
    if (path.indexOf('/pages' + URL_PREFIX) === 0) {
      path = path.replace('/pages' + URL_PREFIX, URL_PREFIX);
    } else if (path === '/pages' + URL_PREFIX) {
      path = URL_PREFIX;
    }

    return { path: path, localePrefix: localePrefix };
  }

  function isKnownStepPath(path) {
    for (var step in STEP_PATHS) {
      if (STEP_PATHS[step] === path) return true;
    }
    return false;
  }

  function getStepFromPath(path) {
    for (var step in STEP_PATHS) {
      if (STEP_PATHS[step] === path) return step;
    }
    return null;
  }

  function isRootUrl(path) {
    if (!getStepFromPath(path)) return true;
    if (path === URL_PREFIX + '/' || path === URL_PREFIX) return true;
    if (path === '/pages/wizard-2/' || path === '/pages/wizard-2') return true;
    if (path.indexOf('/quiz/') === -1 && path.indexOf('/plan/') === -1 && path !== URL_PREFIX + '/profile') {
      return true;
    }
    return false;
  }

  function getPathParam() {
    try {
      return new URLSearchParams(window.location.search).get('__path');
    } catch (e) {
      return null;
    }
  }

  function persistedQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('__path');
      var s = params.toString();
      return s ? '?' + s : '';
    } catch (e) {
      return '';
    }
  }

  function readSavedState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function hasQuizProgress(saved) {
    if (!saved) return false;
    var pet = saved.petData || {};
    return !!(pet.name || pet.gender || pet.ageGroup || pet.breed ||
      pet.weight != null || saved.petMetaobjectId);
  }

  function getResumeStep(saved) {
    if (!saved) return 'name';

    var pet = saved.petData || {};
    var hasLoadedData = pet.name || pet.gender || pet.ageGroup || pet.breed ||
      pet.weight != null || saved.customerId;
    if (!hasLoadedData) return 'name';

    var step = saved.currentStep || 'name';
    if (step === 'get_started') return 'name';
    return STEP_PATHS[step] ? step : 'name';
  }

  function needsCanonicalUrl(path, pathParam) {
    if (pathParam) return true;
    return isRootUrl(path);
  }

  function resolveTargetPath(pathParam, saved) {
    if (pathParam === URL_PREFIX + '/plan/onetime') return URL_PREFIX + '/plan/overview';
    if ((pathParam === STEP_PATHS.get_started || pathParam === URL_PREFIX + '/quiz/get-started') && hasQuizProgress(saved)) {
      return STEP_PATHS[getResumeStep(saved)];
    }
    if (pathParam && isKnownStepPath(pathParam)) return pathParam;
    return STEP_PATHS[getResumeStep(saved)];
  }

  var normalized = normalizePath(window.location.pathname);
  var pathParam = getPathParam();
  var savedEarly = readSavedState();

  if (getStepFromPath(normalized.path) === 'get_started' && hasQuizProgress(savedEarly)) {
    var resumePath = STEP_PATHS[getResumeStep(savedEarly)];
    var resumeQuery = persistedQuery();
    var resumeUrl = normalized.localePrefix + resumePath + resumeQuery;
    var resumeCurrent = window.location.pathname + window.location.search + window.location.hash;
    if (resumeCurrent !== resumeUrl) {
      window.history.pushState({}, '', resumeUrl);
    }
    return;
  }

  if (normalized.path !== URL_PREFIX + '/plan/onetime' && !needsCanonicalUrl(normalized.path, pathParam)) {
    return;
  }

  var saved = savedEarly || readSavedState();
  var targetPath = resolveTargetPath(pathParam, saved);
  if (normalized.path === URL_PREFIX + '/plan/onetime') {
    targetPath = URL_PREFIX + '/plan/overview';
  }
  var query = persistedQuery();
  var hash = window.location.hash || '';
  if (
    normalized.path === URL_PREFIX + '/plan/onetime' ||
    pathParam === URL_PREFIX + '/plan/onetime' ||
    (targetPath === URL_PREFIX + '/plan/overview' && getResumeStep(saved) === 'plan_onetime')
  ) {
    hash = '#onetime';
  } else if (hash === '#onetime' && targetPath !== URL_PREFIX + '/plan/overview') {
    hash = '';
  }
  var targetUrl = normalized.localePrefix + targetPath + query + hash;
  var currentUrl = window.location.pathname + window.location.search + window.location.hash;

  if (currentUrl === targetUrl) return;

  window.history.pushState({}, '', targetUrl);
})();
